exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_error__3zI1F{padding:1.5rem 1rem;color:#db4437;background-color:#f8e8e6;text-align:left}.style_error__3zI1F ul{padding-left:1rem;margin-bottom:0;list-style-type:disc;font-weight:400}.style_titleContainer__2bAHe{display:flex;justify-content:space-between}.style_title__A5dbg{font-weight:500}.style_detailLink__3naxR{padding-top:.25rem;padding-bottom:.25rem}", ""]);

// exports
exports.locals = {
	"error": "style_error__3zI1F",
	"titleContainer": "style_titleContainer__2bAHe",
	"title": "style_title__A5dbg",
	"detailLink": "style_detailLink__3naxR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/ErrorPanel/style.less
// module id = 1105
// module chunks = 8